import { MTableToolbar } from '@material-table/core';
import BaseTable from 'components/Tables/BaseTable';
import TabsBar from 'components/TabsBars/TabsBarsDescriptors';
import { alertError } from 'ducks/alerts';
import { actions as scenariosDescriptorsActions } from 'ducks/scenariosDescriptors';
import { sortBy } from 'lodash';
import ConditionsDetailPanel from 'pages/Flows/FlowScenarios/ConditionsDetailPanel';
import HeaderWSelectors from 'pages/Flows/HeaderWSelectors';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import docDefinition from 'reports/flows/flowScenarios';
import theme from 'source/theme';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/scenarioDescriptors';
import noIcon from 'utils/tables/noIcon';
import { TABLE_HEIGHT } from 'utils/ui/constants';
import { currentUser } from 'selectors/currentUser';

pdfMake.addVirtualFileSystem(pdfFonts);

const Component = props => {
  const {
    conditions, descriptorTab, descriptors, descriptorFilter,
    flow, lcs, scenario, scenarioDescriptors, scenarioDescriptorConditions,
    stepId, steps, takeOutTabsHeader, units, user
  } = props;
  const {
    alertError, backToScenarios, createScenarioDescriptor, closeDescriptors,
    removeScenarioDescriptor, setDescriptor, setDescriptorTab,
  } = props;
  const tableRef = React.useRef(null);


  const filteredDescriptors = descriptors.data.filter(v => v.descriptor_type_id === descriptorFilter);

  const filteredFSD = scenarioDescriptors.filter(fsd =>
    stepId ?
      descriptors.models[fsd.descriptor_id].descriptor_type_id === descriptorFilter && fsd.step_id === stepId :
      descriptors.models[fsd.descriptor_id].descriptor_type_id === descriptorFilter
  );

  const [selectedIds, setSelectedIds] = useState(filteredFSD.map(fsd => fsd.descriptor_id));
  const [loading, setLoading] = useState(false);

  useEffect(
    () => setSelectedIds(filteredFSD.map(fsd => fsd.descriptor_id)),
    [loading, descriptorTab]
  );

  // TODO THIS IS NOT CORRECT OR NEEDED WITH HEADER SELECTOR LIKE IT IS CURRENTLY
  if (!scenario) {
    alertError(
      "Cenário não criado para combinação Fluxograma e Lcs selecionada. " +
      "Por favor crie Cenário de fluxograma primeiro"
    );
    backToScenarios();
  }

  // TODO Adding Checked info to table, there should be a better way
  const rows = filteredDescriptors.map(descriptor =>
    selectedIds.includes(descriptor.id) ?
      { ...descriptor, tableData: { checked: true } } :
      { ...descriptor, tableData: { checked: false } }
  );

  const reOrderedRows = sortBy(rows, [o => !selectedIds.includes(o.id), 'order' ]);

  const manageConditions = rowData => {
    if (rowData.tableData.checked) {
      setDescriptor(rowData);
    } else {
      setLoading(true);
      createScenarioDescriptor(
        stepId ?
          { descriptor_id: rowData.id, scenario_id: scenario.id, step_id: stepId } :
          { descriptor_id: rowData.id, scenario_id: scenario.id }
      )
        .then(() => {
          setDescriptor(rowData);
          setLoading(false);
        })
        .catch(e => alert(e));
    }
  };

  const exportPDF = [
    {
      position: 'toolbarOnSelect',
      icon: tableIcons.Pdf,
      tooltip: 'Exportar PDF',
      onClick: () => {
        pdfMake.createPdf(
          docDefinition(lcs, flow, descriptors, conditions, scenario,
            scenarioDescriptors, scenarioDescriptorConditions, units))
          .open();
      }
    },
    {
      position: 'toolbar',
      icon: tableIcons.Pdf,
      tooltip: 'Exportar PDF',
      onClick: () => {
        pdfMake.createPdf(
          docDefinition(lcs, flow, descriptors, conditions, scenario,
            scenarioDescriptors, scenarioDescriptorConditions, units))
          .open();
      }
    }
  ];

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        titleBack={(closeDescriptors || backToScenarios) && true}
        titleAction={closeDescriptors ? closeDescriptors : backToScenarios}
        title={
          closeDescriptors ?
            `DESCRITORES - ${steps[stepId].name}` :
            <HeaderWSelectors
              disabled={true}
              currentOptionFlow={flow}
              currentOptionLcs={lcs}
              currentOptionScenario={scenario}
            />
        }
        columns={columns(user)}
        data={reOrderedRows}
        order={false}
        onRowClick={() => null}
        onRowDoubleClick={setDescriptor ? manageConditions : undefined}
        paging={false}
        options={{
          actionsCellStyle: {
            paddingLeft: 20
          },
          maxBodyHeight: takeOutTabsHeader ? TABLE_HEIGHT(false, 0) : TABLE_HEIGHT(false, 48),
          minBodyHeight: takeOutTabsHeader ? TABLE_HEIGHT(false, 0) : TABLE_HEIGHT(false, 48),
          selection: true,
          showTextRowsSelected: false,
          showSelectAllCheckbox: false,
          selectionProps: rowData => ({
            //checked: prevInterSubstanceIds.includes(rowData.id)
            //onClick: (event , rowData) => this.handleCheckboxClick(event,rowData),
          })
        }}
        isLoading={loading}
        onSelectionChange={(rows, difRow) => {
          console.log('rows.length', rows.length, selectedIds.length);
          setLoading(true);
          if (rows.length > selectedIds.length) {
            createScenarioDescriptor(stepId ?
              { descriptor_id: difRow.id, scenario_id: scenario.id, step_id: stepId } :
              { descriptor_id: difRow.id, scenario_id: scenario.id }
            )
              .then(() => setLoading(false))
              .catch(e => alert('ERROR', e));
          } else {
            const id_sd = filteredFSD.find(fsd => fsd.descriptor_id === difRow.id).id;
            removeScenarioDescriptor(id_sd)
              .then(() => setLoading(false))
              .catch(e => alert('ERROR', e));
          }
        }}
        actions={setDescriptor ?
          [
            {
              icon: tableIcons.Conditions,
              tooltip: 'Gerir condições',
              onClick: (event, rowData) => manageConditions(rowData),
              position: 'row'
            },
            ...exportPDF
          ] :
          exportPDF
        }
        detailPanel={setDescriptor && [
          rowData => {
            const rowScenarioDescriptor = filteredFSD.find(fsd => fsd.descriptor_id === rowData.id);
            return rowScenarioDescriptor ?
              {
                icon: tableIcons.Conditions,
                tooltip: 'Condições',
                render: () => <ConditionsDetailPanel scenarioDescriptor={rowScenarioDescriptor}/>
              } :
              noIcon;
          }]
        }
        components={{
          Toolbar: props => (
            <div style={{ backgroundColor: theme.palette.background.veryLight }}>
              <MTableToolbar {...props} />
              {!closeDescriptors && <TabsBar value={descriptorTab} setValue={setDescriptorTab}/>}
            </div>
          )
        }}
      />
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  conditions: state.conditions,
  descriptors: state.descriptors,
  scenarioDescriptorConditions: state.scenarioDescriptorConditions.data,
  steps: state.steps.models,
  units: state.units.models,
  user: currentUser(state)
});


const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  createScenarioDescriptor: data => dispatch(scenariosDescriptorsActions.createPromise(data)),
  removeScenarioDescriptor: id => dispatch(scenariosDescriptorsActions.removePromise(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
